import React from "react";
import { createPortal } from 'react-dom';

function Modal({ show, onClose, title, children }) {
  const mouseDownOnBackdrop = React.useRef(false);
  if (!show) return null;

  const modalContent = (
    <div
      className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-40 z-50 "
      onMouseDown={e => {
        if (e.target === e.currentTarget) {
          mouseDownOnBackdrop.current = true;
        } else {
          mouseDownOnBackdrop.current = false;
        }
      }}
      onMouseUp={e => {
        if (e.target === e.currentTarget && mouseDownOnBackdrop.current) {
          onClose();
        }
        mouseDownOnBackdrop.current = false;
      }}
    >
      <div
        className="bg-gray-100 dark:bg-gray-800 rounded-xl relative min-w-[280px] text-gray-900 dark:text-gray-100 border-4 border-solid border-gray-600 bg-gray-100"
        style={{
          maxWidth: 'min(90vw, 760px)',
          width: 'auto',
          maxHeight: '90vh',
          boxSizing: 'border-box',
          overflow: 'auto',
        }}
        onMouseDown={e => e.stopPropagation()}
        onMouseUp={e => e.stopPropagation()}
      >
        <div className="w-full max-w-md  pt-4 pl-4 flex">
        <h2 className="text-xl font-bold mb-4">{title}</h2>
        </div>
        <button
          className="absolute top-2 right-2 text-gray-500 hover:text-gray-700 text-xl font-bold"
          onClick={onClose}
          aria-label="Close"
        >
          &times;
        </button>
        {children}
      </div>
    </div>
  );

  // Use a portal so the modal is appended to document.body and not affected by parent layout
  return typeof document !== 'undefined' ? createPortal(modalContent, document.body) : modalContent;
}

export default Modal;
